import React from "react"
import { headerClass, containerClass } from "../../config/theme"

type Props = { 
  title: string
  subtitle?: string
  icon?: React.ReactNode 
}

export default function PageHeader({ title, subtitle, icon }: Props) {
  return (
    <div className={`mb-6 ${headerClass}`}>
      <div className={`${containerClass} py-6`}>
        <div className="flex items-center gap-3">
          {icon && (
            <div className="flex-shrink-0 text-white/90">
              {icon}
            </div>
          )}
          <div>
            <h1 className="text-2xl font-semibold leading-tight">{title}</h1>
            {subtitle && (
              <p className="text-sm/6 opacity-90 mt-1">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
